import { render, staticRenderFns } from "./NotificationsPanel.vue?vue&type=template&id=ec7112bc&scoped=true&"
import script from "./NotificationsPanel.vue?vue&type=script&lang=js&"
export * from "./NotificationsPanel.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsPanel.vue?vue&type=style&index=0&id=ec7112bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7112bc",
  null
  
)

export default component.exports